export default __webpack_public_path__ + "static/media/information.b3bb71e4.svg";